import {
  CLIENT_TYPE_VISUAL_FALLBACK,
  ClientTypeVisual,
  ORDER_CLIENT_TYPE_VISUAL_MAP,
} from '@constants';

// Badge label always comes from clientTypeName (the API's ready-to-paint
// text) — never re-derived from a local id→label map. clientType only
// selects the style; an id outside the known map still renders its
// clientTypeName, with the neutral fallback style instead of no badge.
export function resolveClientTypeVisual(
  clientType: number | null,
  clientTypeName: string | null,
): (ClientTypeVisual & { label: string }) | null {
  if (!clientTypeName) return null;
  const style =
    (clientType != null && ORDER_CLIENT_TYPE_VISUAL_MAP[clientType]) ||
    CLIENT_TYPE_VISUAL_FALLBACK;
  return { label: clientTypeName, ...style };
}
